<section class="ticket-system-wrap" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
    <div class="ticket-info-row h5">
        <span><ng-container i18n="Total events@@TicketCombiAndSingleTotalEvents">MEČEVA</ng-container><span class="highlight"> {{orderingForTicketItemGroups.length}}</span></span>
        <span><ng-container i18n="Total Odd ticket calculator@@TotalOdd">KVOTA</ng-container> <span class="highlight"> {{ticketData.totalOdd | number: '1.2-2'}}</span></span>
        <!-- <span>UPLATA <span class="highlight">{{totalStake}}</span> <span class="currency bold">{{CV.CURRENCY}}</span></span> -->
    </div>
    <div class="choose-system" *ngIf="systemOptions.length > 1 || !viewConfigurations.useMobileViewWithTopMenu">
        <div class="title" *ngIf="viewConfigurations.useMobileViewWithTopMenu" (click)="showHideSystemOptions()">
            <span i18n="Select System Type ticket calculator@@SelectSystemTypeButton">Odabir sistema</span>
            <i class="icon icon-chevron-down" [class.closed]="showSystemOptions"></i>
        </div>

        <div class="sistem-option" [class.padding]="systemOptions[0]?.numberOfCombinations > 0" *ngIf="showSystemOptions || !viewConfigurations.useMobileViewWithTopMenu || superBetMessageType != superbetMessageTypeEnum.NONE">
            <ul class="system-list-wrap">
            <div *ngIf="superBetMessageType != superbetMessageTypeEnum.NONE">{{superBetMsg}}</div>
            <ng-container *ngFor="let sysOpt of systemOptions; let i = index;">
                <li class="checkbox-wrap" title="Broj kombinacija: {{sysOpt.numberOfCombinations}}"
                [class.disabled]="ticketData.numberOfBets+sysOpt.numberOfCombinations > CV.MAX_COMBINATIONS && !sysOpt.optionSelected || !sysOpt.isSuperBetConditionFulfilled || superBetMessageType != superbetMessageTypeEnum.NONE">
                <input id="sys-{{i}}" type="checkbox" (change)="checkbox(sysOpt)" [checked]="sysOpt.optionSelected">
                <label [attr.for]="'sys-'+i">
                <span *ngIf="!viewConfigurations.useMobileViewWithTopMenu" > {{sysOpt.eventsInCombination}}/{{sysOpt.totalNumberOfEvents}}</span>
                <span *ngIf="viewConfigurations.useMobileViewWithTopMenu" class="sys-opt">
                    <span *ngIf="bankerTicketItemGroups.length > 0">F{{bankerTicketItemGroups.length}}+</span>
                    {{sysOpt.eventsInCombination}}/{{sysOpt.totalNumberOfEvents}}
                    </span>
                </label>
                </li>
            </ng-container>
            </ul>
        </div>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <span i18n="Number of combinations ticket calculator@@NumberOfCombinatuions">Ukupno kombinacija </span>
        <span class="highlight"> {{ticketData.numberOfBets}}</span>
    </div>

    <div [class.hide]="!(ticketData.numberOfBets>0 || systemOptions.length == 0)">
        <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
            <span i18n="Stake per combination ticket calculator@@StakePerCombination">Uplata po kombinaciji </span>
            <!-- <span class="highlight"> {{wagerPerBet | number: displayFormat}} {{CV.CURRENCY}}</span> -->
            <input id="wagerPerBetInputField" type="tel" numberOnly="true" [ngModel]="wagerPerBetString" (ngModelChange)="stakePerBet = $event" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusWagerInput()">
          </div>
        <div class="ticket-info-row">
            <div class="stake-wrap">
                <label for="totalStakeInput" class="btn primary small stake" i18n="Total Stake ticket calculator@@TotalStake">UPLATA</label>
                <div class="bet-input-wrap">
                    <span class="bet-btn minus" (click)="decreaseTotalStake()">-</span>
                    <input *ngIf="isMobileView; else desktop" id="totalStakeInput" type="text" inputmode="decimal" pattern="[0-9]*" numberOnly="true" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()">
                    <ng-template #desktop>
                        <input id="totalStakeInput" type="tel" numberOnly="true" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()">
                    </ng-template>
                    <span class="bet-btn plus" (click)="increaseTotalStake()">+</span>
                </div>
                <label for="totalStakeInput" class="currency btn dark-blue small">{{CV.CURRENCY}}</label>
            </div>
        </div>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.taxBeforeStake > 0">
      <span >Stake per Combination - TAX</span>
      <span class="highlight">{{wagerPerBet | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.taxBeforeStake > 0">
        <span i18n="Tax on payin@@TaxOnPayin">Porez na uplatu </span>
        <span class="highlight">{{ticketData.taxBeforeStake | number: displayFormat}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.totalStake > 0">
        <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog </span>
        <span class="highlight">{{ticketData.totalStake | number: displayFormat}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.bonus > 0">
        <span>Bonus ({{ticketData.bonusPercent}}%) </span>
        <span class="highlight"> {{ticketData.bonus | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>

    <!-- <ng-container *ngIf="ticketData.numberOfBets > 1; else potencialWin"> -->
    <ng-container *ngIf="ticketData.numberOfBets > 1">
        <div class="ticket-info-row">
            <span i18n="Min possible win ticket calculator@@MinPossibleWin">Min potencijalni dobitak </span>
            <span class="highlight" *ngIf="!viewConfigurations.ticketShowPotentalWinWitoutTax"> {{ticketData.minWinings | number: displayFormat}} {{CV.CURRENCY}}</span>
            <span class="highlight" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax"> {{ticketData.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
        <app-winnings-per-hit *ngIf="ticketData.possibleWinForNumberOfHits?.length > 1" [possibleWinForNumberOfHits]="ticketData.possibleWinForNumberOfHits"> </app-winnings-per-hit>
        <!-- <div class="ticket-info-row">
            <span i18n="Max possible win ticket calculator@@MaxPossibleWin">Max potencijalni dobitak </span>
            <span class="highlight"> {{ticketData.possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div> -->

    </ng-container>

    <!-- <ng-template #potencialWin>
        <div class="ticket-info-row" *ngIf="ticketData.totalWinings > 0">
            <span i18n="Max possible win ticket calculator@@MaxPossibleWin">Max potencijalni dobitak </span>
            <span class="highlight"> {{ticketData.possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
    </ng-template> -->

    <div class="ticket-info-row" *ngIf="ticketData.freeBetValue > 0 && viewConfigurations.showPotentialFreeBetWinnings" >
        <span i18n="Possible win ticket calculator@@freeBetValueMob">Potencijalni freebet dobitak</span>
        <span class="highlight"> {{ticketData.freeBetValueToShow | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>

    <div class="ticket-info-row small-text" *ngIf="ticketData.numberOfBets > 1 && viewConfigurations.showBonusMessageOnSystemTicket">
        <p i18n="Multiway ticket description@@SystemDescription">* potencijalni BONUS se obračunava pri finalnoj obradi sistemskog tiketa</p>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <!-- <button id="placeBet" *ngIf="ticketData.isTicketOnline && ((ticketData.numberOfBets > 0 && totalStake >= CV.MIN_STAKE && wagerPerBet >= CV.MIN_STAKE_PER_COMB && ticketData.numberOfBets <= CV.MAX_COMBINATIONS)); else offilneButton"
            (click)="placeBet()" i18n="Proceed to payment ticket calculator button@@ProceedToPayment">PRIPREMA ZA UPLATU</button> -->
        <ng-container *ngIf="ticketData.isTicketOnline && ((ticketData.numberOfBets > 0 && payin >= CV.MIN_STAKE && wagerPerBet >= CV.MIN_STAKE_PER_COMB && ticketData.numberOfBets <= CV.MAX_COMBINATIONS)); else offilneButton">

        </ng-container>

        <ng-template #offilneButton>
            <span *ngIf="!ticketData.isTicketOnline; else onlineWithRestictions" i18n="Offline Events In Ticket ticket calculator button@@OfflineEventsInTicket">OFFLINE događaji na tiketu</span>
            <ng-template #onlineWithRestictions>
                <span *ngIf="ticketData.numberOfBets == 0; else betsNumNotZero" i18n="Select System Type ticket calculator@@SelectSystemTypeButton">ODABERITE TIP SISTEMA</span>
                <ng-template #betsNumNotZero>
                    <ng-container *ngIf="ticketData.numberOfBets > CV.MAX_COMBINATIONS; else betsNumGood">
                        <span i18n="Max Number of combinations ticket calculator button@@MaxNumOfCombinations">MAX KOMBINACIJA</span>:
                        <span class="highlight">{{CV.MAX_COMBINATIONS}}</span>
                    </ng-container>
                    <ng-template #betsNumGood>
                        <ng-container *ngIf="CV.MIN_STAKE > payin; else minStakeGood">
                            <span i18n="Min stake ticket calculator button@@MinStake">MIN UPLATA</span>
                            <span class="highlight">{{CV.MIN_STAKE}} {{CV.CURRENCY}}</span>
                        </ng-container>
                        <ng-template #minStakeGood>
                            <span i18n="Min stake per bet calculator button@@MinStakePerBet">MIN UPLATA PO BETU</span>
                            <span class="highlight">{{CV.MIN_STAKE_PER_COMB}} {{CV.CURRENCY}}</span>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>
        </ng-template>
    </div>

</section>

